export const PUBLIC_SIGN_IN_EVENT = "conversa:public-sign-in";

export function openPublicSignIn() {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new Event(PUBLIC_SIGN_IN_EVENT));
}
